import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import {MenuButtonTaskList} from 'mui-tiptap';

const StyledEditorMenuButtonTaskList = styled(MenuButtonTaskList)`
  ${ComponentStyles}
`;

StyledEditorMenuButtonTaskList.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorMenuButtonTaskList;
